// This file is auto-generated by rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// rails generate stimulus <controllerName>

import { application } from "./application"
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers"

const context = require.context("controllers", true, /\.[tj]s$/)
const contextComponents = require.context("../../components", true, /_controller\.[tj]s$/)
application.load(
  definitionsFromContext(context).concat(
    definitionsFromContext(contextComponents)
  )
)

// view_component-contrib gem edits:
// This allows index.js files in ../../components to act as controllers
const contextContrib = require.context("../../components", true, /index\.js$/)
contextContrib.keys().forEach((path) => {
  const mod = contextContrib(path);

  // Check whether a module has the Controller export defined
  if (!mod.Controller) return;

  // Convert path into a controller identifier:
  //   example/index.js -> example
  //   nav/user_info/index.js -> nav--user-info
  const identifier = path.replace(/^\.\//, '')
    .replace(/\/index\.js$/, '')
    .replace(/\//g, '--')
    .replace(/_/g, '-');

  application.register(identifier, mod.Controller);
});